import { getAspectRatio, getOrientation } from './image'

export const QUEUING_RESIZE = 'queuing_resize'
export const RESIZED = 'resized'
export const QUEUING_CROP = 'queuing_crop'
export const CROPPED = 'cropped'
export const UPLOADED = 'uploaded'
export const FAILED = 'failed'

export class ImageMetadata {
  props = {
    file_name: '',
    file_size: 0,
    mime_type: '',
    image_sizes: [],
    resolution: [],
    color_profile: null,
    public_url: null,
    cropped_thumb_url: null, // only for cropped state.
    exif: []
  };

  constructor(props) {
    this.props = { ...this.props, ...props }
  }

  getFileName() {
    return this.props.file_name
  }

  getFileSize() {
    return this.props.file_size
  }

  getMimeType() {
    return this.props.mime_type
  }

  getImageSizes() {
    return this.props.image_sizes
  }

  getImageWidth() {
    return this.props.image_sizes[0] || 0
  }

  getImageHeight() {
    return this.props.image_sizes[1] || 0
  }

  getResolution() {
    return this.props.resolution
  }

  getColorProfile() {
    return this.props.color_profile
  }

  getPublicUrl() {
    return this.props.public_url
  }
}

export function normalizeUploadSession(raw) {
  const { session, status, expiration } = raw
  const data = raw.data || {}

  const original = data.original
    ? new ImageMetadata(data.original)
    : undefined

  const preview = data.preview
    ? new ImageMetadata(data.preview)
    : undefined

  const thumbnail = data.thumbnail
    ? new ImageMetadata(data.thumbnail)
    : undefined

  const cropped = data.cropped
    ? new ImageMetadata(data.cropped)
    : undefined

  return {
    session,
    status,
    expiration,
    original,
    thumbnail,
    preview,
    cropped,
    processError: null,
    orientation: original ? getOrientation(original.getImageWidth(), original.getImageHeight()) : null,
    aspect: original ? getAspectRatio(original.getImageWidth(), original.getImageHeight()) : null
  }
}
